module.exports = __webpack_public_path__ + "img/thumbnail_WildWaterBuffalo_j_albino.887bf5c2.png";